import React from 'react'
import { CarouselProvider, Slider, Slide} from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import moment from 'moment';

export const Crousal=({data})=> {
  return (
    <CarouselProvider
        naturalSlideWidth={100}
        naturalSlideHeight={120}
        totalSlides={data.length -1}
        visibleSlides={3}
        isPlaying
      >
        <Slider>
          {data.map((val,index)=>{
            if(index !==0){
              return (<>
              <Slide index={Number(index)-1}>
              <div className="row" style={{textAlign:"center"}}>
               <div className="col-12">
               {moment.unix(val.dt).format("ddd")}
               </div>
               <div className="col-12" style={{fontSize: "11px",fontWeight: "bold"}}>
               {moment.unix(val.dt).format("MMM DD YYYY")}
               </div>
               <div className="col-12">
               <img style={{width:"100%"}}src={`assets/img/weather/day${val.weather[0].main}.svg`}/>
               </div>
               <div className="col-12">
               {val.temp.max}<span>&#8451;</span>
               </div>
              </div>
   
             </Slide>
               </>)
            }
            else{
              return false;
            }
           
          })}
         
        
         
        </Slider>
      </CarouselProvider>
  )
}
